



















import { Component, Prop, Vue } from 'vue-property-decorator';


@Component({
    components: {
    },
})
export default class ModalVue extends Vue {

    @Prop({default:true}) private closeable!: boolean;

    close(){
        if(!this.closeable) return;
        this.$emit('close');
    }

}

